var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('van-nav-bar',{attrs:{"title":_vm.$t('home.title.notice')}},[_c('van-icon',{attrs:{"slot":"left","name":"arrow-left","color":"#fff"},on:{"click":function($event){return _vm.$router.back()}},slot:"left"})],1),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.content)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }